import * as Yup from 'yup';
import { OrderApprovalThresholdDirection } from 'types/org';

export const formConstants = {
  orderApprovalThreshold: {
    name: 'orderApprovalThreshold',
    label: 'Approval Threshold',
    description: '',
  },
  orderApprovalThresholdDirection: {
    name: 'orderApprovalThresholdDirection',
    label: 'Approval Threshold Direction',
    description: {
      [OrderApprovalThresholdDirection.UP]:
        'Orders will require approval when the total exceeds the Approval Threshold.',
      [OrderApprovalThresholdDirection.DOWN]:
        'Orders will require approval when the total is below the Approval Threshold.',
    },
    optionLabels: {
      [OrderApprovalThresholdDirection.UP]: 'Upper Threshold',
      [OrderApprovalThresholdDirection.DOWN]: 'Lower Threshold',
    },
  },
};

export const formValidation = Yup.object().shape({
  [formConstants.orderApprovalThreshold.name]: Yup.number()
    .transform((__, originalValue) =>
      originalValue === '' ? null : Number(originalValue.replace(/,/g, ''))
    )
    .nullable(),
  [formConstants.orderApprovalThresholdDirection.name]: Yup.string().oneOf(
    Object.values(OrderApprovalThresholdDirection),
    'Invalid Approval Threshold Direction'
  ),
});
